define((require) => {
    "use strict";

    var _                   = require("underscore"),
        Promise             = require("shared/util/Promise"),
        ImprovedView        = require("editor/zbone/ImprovedView"),
        SequentialButton    = require("util/SequentialButton"),
        SpinnerView         = require("shared/ui/common/SpinnerView"),
        template            = require("ui/projects/AbstractProjectAttachView.tpl");

    var HEADER_TEMPLATE = _.template("<%- label %>&nbsp;<span class='count thin'>&#40;<%- count %>&#41;</span>"),
        NOTIFICATION_TEMPLATE = _.template("<div class='notification-icon' /><%- message %>");

    /**
     *
     * @class AbstractProjectAttachView
     */
    return ImprovedView.extend("AbstractProjectAttachView", {

        template: template,

        tagName: "section",

        className: "project-attach-view",

        regions: {
            contentRegion: ".content-region"
        },

        ui: {
            header: ".attach-header",
            attachButton: ".btn-ok-attach",
            cancelButton: ".btn-cancel-attach",
            notificationMessage: ".notification-message"
        },

        events: {
            "click @ui.attachButton": "_attachClickHandler",
            "click @ui.cancelButton": "_cancelClickHandler"
        },

        collectionView: null,

        _selectedAssets: null,

        _collectionViewInstance: null,

        initialize: function() {
            this._selectedAssets = [];
        },

        collectionOptions: function() {
            return Promise.resolved({});
        },

        onRender: function() {
            this._attach = SequentialButton.add(this.ui.attachButton, this._attach.bind(this, this._selectedAssets), true, true);
        },

        onShow: function() {
            var self = this,
                $el = this.$el,
                contentRegion = this.contentRegion,
                View = this.collectionView,
                itemViewOptions = this._createItemViewOptions();

            contentRegion.show(new SpinnerView());

            $el.addClass("loading");

            this.collectionOptions().then((options) => {
                self.ui.header.html(HEADER_TEMPLATE(options.header));

                delete options.header;

                $el.removeClass("loading");

                self._collectionViewInstance = new View(_.defaults(options, {
                    itemViewOptions: itemViewOptions,
                    scrollTarget: self.contentRegion.$el
                }));

                contentRegion.show(self._collectionViewInstance);
            });
        },

        onSelect: function(model, selected, selectedAssets) { // eslint-disable-line no-unused-vars
        },

        onAttach: function() {
            return Promise.resolved();
        },

        showNotification: function(message) {
            if (!message) {
                return this.ui.notificationMessage.html("");
            }

            var html = NOTIFICATION_TEMPLATE({message: message});
            this.ui.notificationMessage.html(html);
        },

        /**
         * @private
         *
         * Injects the 'selectHandler' into the itemViewOptions of the collection view - making
         * options.selectHandler available for the item view(s).
         *
         * @return {Function} The new item view options function.
         */
        _createItemViewOptions: function() {
            var self = this,
                projectContext = this.options.projectContext,
                selectHandler = this._selectHandler.bind(this);

            return function() {
                var superItemViewOptions = _.result(self.collectionView.prototype, "itemViewOptions") || {};

                return _.extend(superItemViewOptions, {
                    projectContext: projectContext,
                    selectHandler: selectHandler
                });
            };
        },

        _attachClickHandler: function() {
            if (this._selectedAssets.length) {
                this._attach();
            }
        },

        _attach: function(selectedAssets) {
            var self = this;

            return this.options.projectContext
                .attach(selectedAssets)
                .then(self.onAttach.bind(self, selectedAssets))
                .then(() => {
                    self.trigger("attached", selectedAssets);
                })
                .always(self._close.bind(self));
        },

        _close: function() {
            this.trigger("close");
        },

        _cancelClickHandler: function() {
            this._close();
        },

        _selectHandler: function(model, selected) {
            if (selected) {
                this._selectedAssets.push(model);
            } else {
                var i = this._selectedAssets.indexOf(model);
                this._selectedAssets.splice(i, 1);
            }

            this.triggerMethod("select", selected, this._selectedAssets);
        }

    });
});



// WEBPACK FOOTER //
// ./src/editor/ui/projects/AbstractProjectAttachView.js